export default {
  'Heading-1': {
    fontSize: '20px',
    fontStyle: 'normal',
    lineHeight: '122%',
    fontWeight: 700,
    fontFamily: 'Basis Grotesque Arabic Pro',
    color: '#000'
  },
  'Heading-2': {
    fontFamily: 'Overused Grotesk',
    fontSize: '42px',
    fontStyle: 'normal',
    fontWeight: 350,
    lineHeight: '48px'
  },
  'Heading-3': {
    fontFamily: 'Overused Grotesk',
    color: '#066E82',
    fontSize: '34px',
    fontStyle: 'normal',
    fontWeight: 350,
    lineHeight: '48px'
  },
  'Heading-4': {
    fontFamily: 'Overused Grotesk',
    color: '#066E82',
    fontSize: '28px',
    fontStyle: 'normal',
    fontWeight: 350,
    lineHeight: '36px'
  },
  'Heading-L-Medium': {
    fontWeight: 500,
    fontSize: 32,
    fontStyle: 'normal',
    fontFamily: 'Overused Grotesk',
    lineHeight: '130%'
  },
  'Heading-L-regular': {
    fontWeight: 400,
    fontSize: 32,
    fontStyle: 'normal',
    fontFamily: 'Overused Grotesk',
    lineHeight: '130%'
  },
  'Heading-L-Light': {
    fontWeight: 300,
    fontSize: 32,
    fontStyle: 'normal',
    fontFamily: 'Overused Grotesk',
    lineHeight: '130%'
  },
  'Heading-M-Medium': {
    fontWeight: 500,
    fontSize: 24,
    fontStyle: 'normal',
    fontFamily: 'Overused Grotesk',
    lineHeight: '130%'
  },
  'Heading-M-regular': {
    fontWeight: 400,
    fontSize: 24,
    fontStyle: 'normal',
    fontFamily: 'Overused Grotesk',
    lineHeight: '130%'
  },
  'Heading-M-Light': {
    fontWeight: 300,
    fontSize: 24,
    fontStyle: 'normal',
    fontFamily: 'Overused Grotesk',
    lineHeight: '130%'
  },
  'Heading-S-Medium': {
    fontWeight: 500,
    fontSize: 20,
    fontStyle: 'normal',
    fontFamily: 'Overused Grotesk',
    lineHeight: '130%'
  },
  'Heading-S-regular': {
    fontWeight: 400,
    fontSize: 20,
    fontStyle: 'normal',
    fontFamily: 'Overused Grotesk',
    lineHeight: '130%'
  },
  'Heading-S-Light': {
    fontWeight: 300,
    fontSize: 20,
    fontStyle: 'normal',
    fontFamily: 'Overused Grotesk',
    lineHeight: '130%'
  },
  'Body-XL-Regular': {
    fontFamily: 'Overused Grotesk',
    color: '#252527',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '32px'
  },
  'Body-L-Medium': {
    fontWeight: 500,
    fontSize: 16,
    fontStyle: 'normal',
    fontFamily: 'Overused Grotesk',
    lineHeight: '130%'
  },
  'Body-L-regular': {
    fontFamily: 'Overused Grotesk',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '26px'
  },
  'Body-L-Light': {
    fontWeight: 300,
    fontSize: 16,
    fontStyle: 'normal',
    fontFamily: 'Overused Grotesk',
    lineHeight: '130%'
  },
  'Body-M-Medium': {
    fontFamily: 'Overused Grotesk',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px'
  },
  'Body-M-regular': {
    fontFamily: 'Overused Grotesk',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px'
  },
  'Body-M-Light': {
    fontFamily: 'Overused Grotesk',
    color: '#1D1B20',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 300,
    lineHeight: '24px'
  },
  'Body-S-Medium': {
    fontFamily: 'Overused Grotesk',
    color: '#1D1B20',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px'
  },
  'Body-S-regular': {
    fontFamily: 'Overused Grotesk',
    color: '#1D1B20',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px'
  },
  'Body-S-Light': {
    fontFamily: 'Overused Grotesk',
    color: '#1D1B20',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px'
  },
  'Body-XS-regular': {
    fontFamily: 'Overused Grotesk',
    color: '#49454F',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '18px'
  },
  'Title-M-regular': {
    fontFamily: 'Roboto',
    color: '#1D1B20',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px'
  },
  'Title-M-regular-sansSerif': {
    fontFamily: 'Roboto, sans-serif',
    color: '#1D1B20',
    fontSize: '16px',
    fontWeight: 600
  },
  'Title-S-regular': {
    fontFamily: 'Roboto',
    color: '#1D1B20',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.1px'
  },
  'Title-S-bold': {
    fontFamily: 'Roboto',
    color: '#1D1B20',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px',
    letterSpacing: '0.1px'
  },
  'table-S-bold': {
    fontFamily: 'Roboto, sans-serif',
    color: '#1D1B20',
    fontSize: '16px',

    fontWeight: 600
  }
};
